import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isNullOrEmpty } from "../../_utils/generalUtils";

/*
 * ErrorAlert Component
 * Purpose: Provides a generic, simple dialog box
 * Notes: Dependent components must provide title (alertTitle), body text
 *        (alertText), accept button caption (acceptCaption), reject button
 *        caption (rejectText), and event handlers. Also, the provideReject
 *        prop (a bool) indicates if there is a reject button (i.e. false if
 *        the dialog is to contain only 'OK' button.)
 */
class ErrorAlert extends Component {
  state = { showDetails: false };

  toggleDetails = (e) => {
    e.preventDefault();
    this.setState({ showDetails: !this.state.showDetails });
  };

  renderError = () => {
    const { errorContext } = this.props;
    const { showDetails } = this.state;
    const error = errorContext.error;
    if (error) {
      const splitCustomMsg = error.customMessage
        ? error.customMessage
            .split(/\r\n|\r|\n/g)
            .map((at, i) => <span key={`alertSpanKey_${i}`}>{at}</span>)
        : error || [
            "Could not retrieve error object. Please contact the system administrator.",
          ];
      if (error.isSystemException) {
        return (
          <React.Fragment>
            <p>{splitCustomMsg}</p>
            <p>Please contact the system administrator.</p>
            <hr className="my-2" />
            <button
              type="button"
              name="showDetails"
              id="showDetails"
              className="btn btn-sm btn-outline-secondary mb-2"
              onClick={this.toggleDetails}
            >
              {showDetails ? "Hide Error Details" : "Show Error Details"}
              <FontAwesomeIcon
                className="ml-2"
                icon={showDetails ? "angle-up" : "angle-down"}
              />
            </button>
            <Collapse isOpen={showDetails}>
              <p>
                <b>Action: </b>
                {errorContext.type}
              </p>
              <p>
                <b>Type: </b>
                {error.type}
              </p>
              <p>
                <b>TargetSite: </b>
                {error.targetSite}
              </p>
              <p>
                <b>Message: </b>
                {error.message}
              </p>
              <p>
                <b>InnerException: </b>
                {!isNullOrEmpty(error.innerException) ? error.innerException : "(None)"}
              </p>
            </Collapse>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <p>{splitCustomMsg}</p>
          </React.Fragment>
        );
      }
    }
  };

  render() {
    const { handleAlertAction, toggleErrorAlert, showErrorAlert, errorContext } =
      this.props;
    return (
      <Modal isOpen={showErrorAlert} toggle={toggleErrorAlert} size={"md"} fade={false}>
        <ModalHeader className="bg-danger text-white">
          <FontAwesomeIcon icon="times-circle" className="mr-2" />
          Error
        </ModalHeader>
        <ModalBody>{this.renderError()}</ModalBody>
        <ModalFooter className="bg-lightgray">
          <Button
            color="danger"
            onClick={handleAlertAction("accept", errorContext.errorId)}
          >
            OK
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ErrorAlert;
